import React, { useState, useEffect, useRef } from "react";
import { Link, useStaticQuery, graphql } from "gatsby";
import { useClickAway, useKeyPressEvent } from "react-use";
import "./styles.scss";
import SubMenu from "../SubMenu";

function MainNav() {
	const data = useStaticQuery(graphql`
		query MainMenu {
			contentfulMenu(title: { eq: "Header Main Menu" }) {
				menuItems {
					contentful_id
					title
					slug
					subMenu {
						menuItems {
							contentful_id
							title
							slug
							description
							icon {
								svg {
									content
								}
							}
						}
					}
				}
			}
		}
	`);

	const mainMenu = data.contentfulMenu.menuItems;

	const [openSubMenu, setOpenSubMenu] = useState(null);
	const menuRef = useRef();

	useClickAway(menuRef, () => {
		setOpenSubMenu(null);
	});

	useKeyPressEvent("Escape", () => {
		if (openSubMenu) {
			setOpenSubMenu(null);
		}
	});

	useKeyPressEvent("Tab", null, event => {
		if (openSubMenu && !event.target.classList.contains("submenu__link")) {
			setOpenSubMenu(null);
		}
	});

	const handleSubMenuButtonClick = subMenuTitle => {
		if (subMenuTitle === openSubMenu) {
			setOpenSubMenu(null);
			return;
		}

		setOpenSubMenu(subMenuTitle);
	};

	useEffect(() => {
		if (openSubMenu) {
			document.querySelector("body").classList.add("submenu-open");
		} else {
			document.querySelector("body").classList.remove("submenu-open");
		}
	}, [openSubMenu]);

	return (
		<nav aria-label="primary-navigation">
			<ul className="main-nav" ref={menuRef}>
				{mainMenu.map((menuItem, index) => {
					if (menuItem.subMenu) {
						return (
							<li key={index}>
								<button
									onClick={() => handleSubMenuButtonClick(menuItem.title)}
									className="btn btn--link"
									aria-haspopup="true"
									aria-expanded={
										openSubMenu === menuItem.title ? "true" : "false"
									}
								>
									{menuItem.title}
								</button>
								<SubMenu
									title={menuItem.title}
									menuItems={menuItem.subMenu.menuItems}
									openSubMenu={openSubMenu}
								/>
							</li>
						);
					} else {
						return (
							<li key={index}>
								<Link to={`/${menuItem.slug}`}>
									{menuItem.title}
								</Link>
							</li>
						);
					}
				})}
			</ul>
		</nav>
	);
}

export default MainNav;
